<template>
  <custom-dialog :visible="visible" width="680px" class="device-warehousing-dialog" :title="model.title" v-on="$listeners">
    <div class="dialog-body">
      <div class="msg-content">
        <div class="title">{{ $t('dms_device_warehousing_dialog.Modemxin_xi') }}</div>
        <ul class="msg-list">
          <li>
            <div class="key">{{ $t('dms_device_warehousing_dialog.chan_pinSN') }}</div>
            <div class="val">{{ model.data.productSn || '-' }}</div>
          </li>
          <li>
            <div class="key">{{ $t('dms_device_warehousing_dialog.chan_pin_xing_hao') }}</div>
            <div class="val">{{ model.data.productCode || '-' }}</div>
          </li>
          <li>
            <div class="key">{{ 'Modem SN' }}</div>
            <div class="val">{{ model.data.modemSn || '-' }}</div>
          </li>
          <li>
            <div class="key">{{ $t('dms_device_warehousing_dialog.sheng_yu_dian_liang') }}</div>
            <div class="val">{{ model.data.batteryCharge || '-' }}</div>
          </li>
          <li>
            <div class="key">{{ $t('dms_device_warehousing_dialog.dcsjgxsj') }}</div>
            <div class="val">{{ lastDataUpdateTime }}</div>
          </li>
          <li>
            <div class="key">{{ $t('dms_device_warehousing_dialog.ISTzhan_dian') }}</div>
            <div class="val">{{ model.data.websiteName || '-' }}</div>
          </li>
          <li>
            <div class="key">{{ $t('dms_device_warehousing_dialog.zhan_dian_zhuang_tai') }}</div>
            <div class="val">{{ getDicValue('website_state', model.data.websiteState) || '-' }}</div>
          </li>
          <li>
            <div class="key">{{ $t('dms_device_warehousing_dialog.xie_yi_lei_bie') }}</div>
            <div class="val">{{ getDicValue('iot_protocol_class', model.data.protocolClass) || '-' }}</div>
          </li>
          <li>
            <div class="key">{{ $t('dms_device_warehousing_dialog.xie_yi_ji_ban_ben') }}</div>
            <div class="val">{{ model.data.protocolCode || '-' }}/{{ model.data.tcpVersion || '-' }}</div>
          </li>
        </ul>
      </div>
      <div class="input-container">
        <el-form :model="form" :rules="rules" ref="form">
          <!-- <el-form-item :label="$t('label_product_sn" prop="productSn">
            <custom-select
              url="productValidList"
              filterable
              v-model="form.productSn"
              :props="{ label: 'snCodeCountry', value: 'productSn' }"
              @change="onProductSnChange"
              width="100%"
            ></custom-select>
          </el-form-item> -->
          <!-- <el-form-item :label="$t('label_product_code" prop="productCode">
            <el-input v-model="form.productCode" placeholder="" :disabled="true"></el-input>
          </el-form-item> -->
          <el-form-item :label="$t('dms_device_warehousing_dialog.ji_shen_hao')" prop="bodyNum">
            <el-input v-model="form.bodyNum" placeholder=""></el-input>
          </el-form-item>
          <!-- <el-form-item :label="$t('label_countyCode" prop="countryCode">
            <custom-select v-model="form.countryCode"  url="NationTree"  :props="{ label: 'name', value: 'code' }" width="100%px" @change="changCounty"></custom-select>
          </el-form-item> -->
          <el-form-item :label="$t('dms_device_warehousing_dialog.ru_ku_ri_qi')" prop="stockInTime">
            <custom-date-picker style="width: 100%" v-model="form.stockInTime" type="date" value-format="YYYY-MM-DD HH:mm:ss" :picker-options="beforeToday"></custom-date-picker>
          </el-form-item>
          <el-form-item :label="$t('dms_device_warehousing_dialog.ru_ku_dan_hao')" prop="shipmentNum">
            <el-input v-model="form.shipmentNum" placeholder=""></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_close') }}</el-button>
      <el-button type="primary" @click="onSave">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import moment from 'moment';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        productSn: '',
        productCode: '',
        stockInTime: '',
        bodyNum: '', // 设备机身号
        shipmentNum: '', // 入库订单号
        countryCode: '',
        country: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        productSn: {
          required: true,
          message: this.$t('dms_device_warehousing_dialog.qxzcpSN'),
        },
        productCode: {
          required: true,
          message: this.$t('dms_device_warehousing_dialog.qxzcpxh'),
        },
        bodyNum: {
          required: true,
          type: 'string',
          max: 30,
          message: this.$t('Common.com_rules_length_max', [30]),
        },
        stockInTime: {
          required: true,
          type: 'string',
          message: this.$t('dms_device_warehousing_dialog.qxzrksj'),
        },
        countryCode: {
          required: true,
          type: 'string',
          message: this.$t('dms_device_warehousing_dialog.qxzfwgj'),
        },
        shipmentNum: {
          type: 'string',
          max: 30,
          message: this.$t('Common.com_rules_length_max', [30]),
        },
      };
    },
    lastDataUpdateTime() {
      if (this.model.data.lastDataUpdateTime) {
        return moment(this.model.data.lastDataUpdateTime).format('YYYY-MM-DD HH:mm');
      }
      return '-';
    },
  },
  mounted: function () {
    // this.form.productCode = this.model.data.productCode || '';
  },
  methods: {
    changCounty(item) {
      this.form.country = item ? item.name : '';
    },
    onProductSnChange(item) {
      this.form.productCode = item ? item.productCode : '';
    },
    onSave() {
      this.$refs.form.validate((val) => {
        if (val) {
          this.form.modemSn = this.model.data.modemSn;
          // this.form.productCode = this.model.data.productCode;
          this.$postJSON(apis.DeviceTestReportStockIn, this.form).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.clearKeepAlive('factoryStock');
            this.$emit('success');
            this.visible = false;
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.device-warehousing-dialog {
  .el-form-item__label {
    width: 100%;
    text-align: left;
  }

  .el-select {
    width: 100%;
  }

  .dialog-body {
    width: 100%;
    padding: 0 !important;
    display: flex;
    .msg-content {
      width: 260px;
      padding: 0 24px 40px;
      height: 100%;
      background: #f8f9fb;
      .title {
        $h: 60px;
        height: $h;
        line-height: $h;
        color: #495057;
        font-weight: bold;
        font-size: 14px;
      }
      .msg-list {
        > li {
          overflow: hidden;
          padding-top: 9px;
          padding-bottom: 10px;
          color: #6c757d;
          font-size: 12px;
          line-height: 17px;
          border-bottom: 1px solid #eef2f7;
          .key {
            float: left;
            width: 50%;
          }
          .val {
            float: left;
            text-align: right;
            width: 50%;
          }
        }
      }
    }
    .input-container {
      flex: 1;
      padding: 24px 24px 0 24px;
      background: #fff;
    }
  }
}
</style>
